import type { SlotBattle } from './types';

/**
 * What the dialog's countdown pill counts down to: the start while the run is upcoming, the end while
 * it is live. Settling and settled have nothing left to count, so the pill is hidden — and so is a
 * target that has already passed, since the server keeps saying `live` for a short grace after the end.
 */
export function selectCountdownTarget(
  battle: Pick<SlotBattle, 'state' | 'startDate' | 'endDate'>,
  now: number = Date.now(),
): Date | null {
  const iso = battle.state === 'upcoming' ? battle.startDate : battle.state === 'live' ? battle.endDate : null;

  if (!iso) {
    return null;
  }

  const target = new Date(iso);
  return Number.isNaN(target.getTime()) || target.getTime() <= now ? null : target;
}
